import React from 'react'
import Posts from '../components/Posts'

function Home() {
  return (
    <Posts />
  )
}

export default Home